import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import CancelIcon from "@mui/icons-material/Cancel";

const items = [
  { Icon: CheckCircleIcon, color: "#4caf50", label: "Livre" },
  { Icon: WatchLaterIcon, color: "#ff9800", label: "Parcial" },
  { Icon: CancelIcon, color: "#f44336", label: "Ocupado" },
];

export const CalendarStatusLegend = () => (
  <Stack
    direction="row"
    spacing={3}
    sx={{ justifyContent: "center", mt: 2 }}
  >
    {items.map(({ Icon, color, label }) => (
      <Stack key={label} direction="row" spacing={0.5} alignItems="center">
        <Icon sx={{ fontSize: 20, color }} />
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
